import ColorSelector from '@v4/common/components/molecules/ColorSelector/ColorSelector';

export default ColorSelector;
